(function(){
  // Predictive search (search page)
  var pin=document.querySelector('[data-search-input]'),pbox=document.querySelector('[data-search-live]');
  if(pin&&pbox){var pt,pc;
    function pHide(){pbox.hidden=true;pbox.innerHTML=''}
    function pRun(){var q=pin.value.trim();if(q.length<2){pHide();return}
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json()}).then(function(j){var ps=(j.resources&&j.resources.results&&j.resources.results.products)||[];
        if(!ps.length){pbox.innerHTML='<p class="slive__none">No matching fragrances</p>';pbox.hidden=false;return}
        pbox.innerHTML=ps.map(function(p){var img=p.image?p.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2'):'';return '<a class="slive__row" href="'+p.url+'">'+(img?'<img src="'+img+'" alt="" width="48" height="60">':'')+'<span class="slive__t">'+p.title+'</span><span class="slive__p">£'+p.price+'</span></a>'}).join('');pbox.hidden=false})
      .catch(function(){pHide()})}
    pin.addEventListener('input',function(){clearTimeout(pt);pt=setTimeout(pRun,250)});
    pin.addEventListener('focus',function(){if(pin.value.trim().length>=2&&pbox.innerHTML)pbox.hidden=false});
    document.addEventListener('click',function(e){if(!e.target.closest('.search-head'))pHide()});
  }

  var h=document.querySelector('.header');
  function sc(){h&&h.classList.toggle('scrolled',window.scrollY>10)}
  window.addEventListener('scroll',sc,{passive:true});sc();

  var drawer=document.getElementById('Drawer');
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-drawer]');
    if(t&&drawer){drawer.classList.toggle('open');document.body.style.overflow=drawer.classList.contains('open')?'hidden':''}
    var s=e.target.closest('[data-search]');
    if(s){var b=document.getElementById('SearchBar');if(b){b.classList.toggle('open');var i=b.querySelector('input');if(b.classList.contains('open')&&i)i.focus()}}
  });
  document.addEventListener('keydown',function(e){if(e.key!=='Escape')return;if(drawer&&drawer.classList.contains('open')){drawer.classList.remove('open');document.body.style.overflow=''}var sb=document.getElementById('SearchBar');if(sb)sb.classList.remove('open')});

  var toast=document.getElementById('Toast');
  function say(m){toast.textContent=m;toast.classList.add('show');setTimeout(function(){toast.classList.remove('show')},2600)}

  // Ajax add to bag
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches('form[action*="/cart/add"]'))return;
    if(e.submitter&&(e.submitter.name==='checkout'||e.submitter.closest('.shopify-payment-button')))return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]');var old=btn.innerHTML;btn.disabled=true;btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok)throw r;return r.json()})
      .then(function(){return fetch('/cart.js').then(function(r){return r.json()})})
      .then(function(c){renderCart(c);openCart()})
      .catch(function(r){return r.json?r.json().then(function(j){say(j.description||'Could not add this item')}):say('Could not add this item')})
      .finally(function(){btn.disabled=false;btn.innerHTML=old});
  });

  // PDP gallery
  document.querySelectorAll('[data-thumb]').forEach(function(b){
    b.addEventListener('click',function(){
      var m=document.getElementById('PdpMain');m.src=b.dataset.src;
      var c=document.getElementById('PdpCount');if(c){var idx=[].slice.call(document.querySelectorAll('[data-thumb]')).indexOf(b)+1;c.textContent=(idx<10?'0':'')+idx+' / '+c.textContent.split('/')[1].trim()}
      document.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('on')});b.classList.add('on');
    });
  });
  var pm=document.querySelector('.pdp__main');
  if(pm){pm.addEventListener('mousemove',function(e){var r=pm.getBoundingClientRect();var i=pm.querySelector('img');i.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'})}

  // copy link (share row)
  document.addEventListener('click',function(e){
    var cp=e.target.closest('[data-copy]');if(!cp)return;
    if(navigator.clipboard){navigator.clipboard.writeText(cp.dataset.copy).then(function(){say('Link copied')})}
  });
  // carousel scroll buttons (arrows)
  document.addEventListener('click',function(e){
    var sb=e.target.closest('[data-scroll]');if(!sb)return;
    var grp=sb.closest('.group');var rail=grp&&grp.querySelector('.grid--5');if(rail){rail.scrollBy({left:parseInt(sb.dataset.scroll,10)*rail.clientWidth*0.8,behavior:'smooth'})}
  });

  // qty
  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-qty]');if(!q)return;
    var i=q.parentNode.querySelector('input');var v=parseInt(i.value||1,10)+parseInt(q.dataset.qty,10);i.value=Math.max(v,i.min?+i.min:1);
    i.dispatchEvent(new Event('change',{bubbles:true}));
  });
  // variant -> id
  var vf=document.getElementById('ProductForm');
  if(vf){
    var data=JSON.parse(document.getElementById('ProductJson').textContent);
    function upd(){
      var sel=[].slice.call(vf.querySelectorAll('.opt')).map(function(o){var c=o.querySelector('input:checked');return c?c.value:null});
      var v=data.variants.find(function(v){return v.options.every(function(o,i){return o===sel[i]})});
      var btn=vf.querySelector('[type=submit]');
      var f=function(c){return '£'+(c/100).toFixed(2)};
      if(!v){btn.disabled=true;btn.textContent='Unavailable';return}
      vf.querySelector('[name=id]').value=v.id;
      btn.disabled=!v.available;
      btn.innerHTML=v.available?((btn.dataset.label||'Add to bag')+' — <span data-atc-price>'+f(v.price)+'</span>'):'Sold out';
      var p=vf.closest('.pdp__info').querySelector('.price');
      p.innerHTML='<b>'+f(v.price)+'</b>'+(v.compare_at_price>v.price?'<s>'+f(v.compare_at_price)+' RRP</s><span class="save">Save '+f(v.compare_at_price-v.price)+'</span>':'');
      if(v.featured_image){document.getElementById('PdpMain').src=v.featured_image.src}
      history.replaceState(null,'','?variant='+v.id);
    }
    vf.addEventListener('change',upd);
  }
})();

  // homepage reviews rotator
  document.querySelectorAll('[data-rev-stage]').forEach(function(stage){
    var slides=stage.querySelectorAll('.revslide');if(slides.length<2)return;
    var dots=stage.querySelectorAll('[data-rev-dot]');var cur=0,timer;
    function go(i){slides[cur].classList.remove('on');if(dots[cur])dots[cur].classList.remove('on');cur=(i+slides.length)%slides.length;slides[cur].classList.add('on');if(dots[cur])dots[cur].classList.add('on')}
    function auto(){timer=setInterval(function(){go(cur+1)},6000)}
    dots.forEach(function(d){d.addEventListener('click',function(){clearInterval(timer);go(parseInt(d.dataset.revDot,10));auto()})});
    stage.addEventListener('mouseenter',function(){clearInterval(timer)});
    stage.addEventListener('mouseleave',auto);
    auto();
  });

  // cart drawer
  function setCount(n){document.querySelectorAll('.cart-count').forEach(function(c){c.textContent=n;c.dataset.n=n})}
  var cd=document.getElementById('CartDrawer');
  function money(c){return '£'+(c/100).toFixed(2)}
  function renderCart(cart){
    setCount(cart.item_count);
    if(!cd)return;
    var ct=cd.querySelector('[data-cart-count-text]');if(ct)ct.textContent=cart.item_count+(cart.item_count===1?' item':' items')+' in your cart';
    var box=cd.querySelector('[data-cart-items]');if(!box)return;
    if(!cart.items.length){box.innerHTML='<p style="padding:18px 0;color:var(--muted)">Your bag is empty.</p>';cd.querySelector('[data-cart-foot]').style.display='none'}
    else{
      cd.querySelector('[data-cart-foot]').style.display='';
      box.innerHTML=cart.items.map(function(it,i){
        return '<div class="citem">'+(it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_200x$1$2')+'" alt="">':'')
        +'<div class="citem__main"><a class="citem__t" href="'+it.url+'">'+it.product_title+'</a>'
        +(it.vendor?'<span class="citem__v">'+it.vendor.replace(/_/g,' ').replace(/,S/g,'\u2019S')+'</span>':(it.variant_title&&it.variant_title!=='Default Title'?'<span class="citem__v">'+it.variant_title+'</span>':''))
        +'<div class="citem__p"><b>'+money(it.final_price)+'</b>'+(it.original_price>it.final_price?'<s>'+money(it.original_price)+'</s>':'')+'</div>'
        +'<span class="citem__qty"><button type="button" data-cqty="'+i+',-1" aria-label="Less">−</button><span>'+it.quantity+'</span><button type="button" data-cqty="'+i+',1" aria-label="More">+</button></span></div>'
        +'<button class="citem__rm" type="button" data-cremove="'+i+'" aria-label="Remove"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2m-8 0l1 13h8l1-13"/></svg></button></div>'
      }).join('');
    }
    var free=cart.total_price>=5000;
    var bn=cd.querySelector('[data-cart-banner]');if(bn)bn.textContent=free?'Free UK delivery on every order':('Add '+money(5000-cart.total_price)+' more for free UK delivery');
    var st=cd.querySelector('[data-cart-subtotal]');if(st)st.textContent=money(cart.total_price);
    var sh=cd.querySelector('[data-cart-shipping]');if(sh){if(cart.item_count&&free){sh.innerHTML='<span class="free-txt">Free</span>'}else{sh.textContent=cart.item_count?'At checkout':'—'}}
    var tt=cd.querySelector('[data-cart-total]');if(tt)tt.textContent=money(cart.total_price);
  }
  function refreshCart(open){
    return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){renderCart(c);if(open)openCart()});
  }
  function openCart(){if(!cd)return;cd.classList.add('open');cd.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}
  function closeCart(){if(!cd)return;cd.classList.remove('open');cd.setAttribute('aria-hidden','true');document.body.style.overflow=''}
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-close]')){closeCart();return}
    var q=e.target.closest('[data-cqty]');
    if(q){var parts=q.dataset.cqty.split(',');var idx=parseInt(parts[0],10);
      fetch('/cart.js').then(function(r){return r.json()}).then(function(c){var it=c.items[idx];if(!it)return;
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:idx+1,quantity:Math.max(0,it.quantity+parseInt(parts[1],10))})}).then(function(r){return r.json()}).then(renderCart)});return}
    var rm=e.target.closest('[data-cremove]');
    if(rm){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(rm.dataset.cremove,10)+1,quantity:0})}).then(function(r){return r.json()}).then(renderCart)}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});
  if(cd)refreshCart(false);

  // cart page qty -> instant update
  document.addEventListener('change',function(e){
    var inp=e.target.closest('[data-cart-line]');if(!inp)return;
    var line=parseInt(inp.dataset.cartLine,10);var qty=Math.max(0,parseInt(inp.value||'0',10));
    inp.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(){location.reload()})
      .catch(function(){inp.disabled=false});
  });
  // PDP zoom lightbox
  var zb=document.getElementById('ZoomBox');
  if(zb){
    var zimg=document.getElementById('ZoomImg'),zcount=document.getElementById('ZoomCount');
    var zlist=[].slice.call(document.querySelectorAll('[data-zoom]')),zcur=0;
    function zshow(i){zcur=(i+zlist.length)%zlist.length;zimg.src=zlist[zcur].dataset.full||zlist[zcur].src;zcount.textContent=((zcur+1<10?'0':'')+(zcur+1))+' / '+((zlist.length<10?'0':'')+zlist.length)}
    function zopen(i){zshow(i);zb.hidden=false;document.body.style.overflow='hidden'}
    function zclose(){zb.hidden=true;document.body.style.overflow=''}
    zlist.forEach(function(im,i){im.closest('.pdp__cell').addEventListener('click',function(){zopen(i)})});
    zb.querySelector('[data-zclose]').addEventListener('click',zclose);
    zb.querySelector('[data-zprev]').addEventListener('click',function(){zshow(zcur-1)});
    zb.querySelector('[data-znext]').addEventListener('click',function(){zshow(zcur+1)});
    zb.addEventListener('click',function(e){if(e.target===zb)zclose()});
    document.addEventListener('keydown',function(e){if(zb.hidden)return;if(e.key==='Escape')zclose();if(e.key==='ArrowLeft')zshow(zcur-1);if(e.key==='ArrowRight')zshow(zcur+1)});
  }
  // gentle scroll-reveal, like the reference site's motion
  var rvEls=document.querySelectorAll('.section,.feat,.group,.edit,.step,.banner,.faqcard,.card,.attr');
  if(rvEls.length&&'IntersectionObserver' in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('rv-in');io.unobserve(en.target)}})},{threshold:.07});
    rvEls.forEach(function(el){el.classList.add('rv');io.observe(el)});
  }

  // drawer recommendations arrows
  document.addEventListener('click',function(e){
    var rb=e.target.closest('[data-rec]');if(!rb)return;
    var rail=rb.closest('.cdrawer__recs').querySelector('.cdrawer__rail');if(rail){rail.scrollBy({left:parseInt(rb.dataset.rec,10)*280,behavior:'smooth'})}
  });

  // PDP tabs
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-tab]');if(!t)return;
    var wrap=t.closest('[data-tabs]');if(!wrap)return;
    wrap.querySelectorAll('[data-tab]').forEach(function(b){b.classList.toggle('is-on',b===t);b.setAttribute('aria-selected',b===t?'true':'false')});
    wrap.querySelectorAll('[data-panel]').forEach(function(p){p.classList.toggle('is-on',p.dataset.panel===t.dataset.tab)});
  });
